module.exports = __webpack_public_path__ + "static/1-d46cabf164ec9923d31b5a5bc17f2ccf.jpg";